import React from 'react';
import { useLocation } from 'react-router-dom';

import SignIn from '../SignIn';

const AutoLogin: React.FC = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const email = params.get('email') || '';
  const password = params.get('senha') || params.get('password') || '';

  return <SignIn initialData={{ email, password }} />;
};

export default AutoLogin;
